import * as React from 'react';
import lazyWithPreload from 'react-lazy-with-preload';
const SuspenseComponent = process.env.SSR
    ? function FakeSuspense(props) {
        return React.createElement(React.Fragment, null, props.children);
    }
    : React.Suspense;
export const Suspense = SuspenseComponent;
export const factoryMap = new Map();
export const lazy = process.env.SSR
    ? function ssrLazy(factory) {
        factoryMap.set(factory, undefined);
        return React.forwardRef(function LazyComponent(props, ref) {
            const LoadedComponent = factoryMap.get(factory);
            return LoadedComponent ? (React.createElement(LoadedComponent, Object.assign({}, props, { ref: ref }))) : null;
        });
    }
    : lazyWithPreload; // we don't use React.lazy because merely call dynamic import will still cause React to suspend.
//# sourceMappingURL=lazy.js.map